import axios from 'axios';
import client from './client';

// Separate Axios instance for the public survey routes: no auth interceptor,
// no withCredentials. The token in the URL is the only credential.
const publicClient = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
});

export const surveysApi = {
  // Authenticated: per-customer
  async listForCustomer(customerId, params = {}) {
    const { data } = await client.get(`/api/customers/${customerId}/surveys`, { params });
    return data;
  },
  async createForCustomer(customerId, body) {
    const { data } = await client.post(`/api/customers/${customerId}/surveys`, body);
    return data;
  },

  // Authenticated: per-invitation
  async get(id) {
    const { data } = await client.get(`/api/surveys/${id}`);
    return data;
  },
  async patch(id, body) {
    const { data } = await client.patch(`/api/surveys/${id}`, body);
    return data;
  },
  async revoke(id) {
    const { data } = await client.post(`/api/surveys/${id}/revoke`);
    return data;
  },
  async regenerateToken(id) {
    const { data } = await client.post(`/api/surveys/${id}/regenerate-token`);
    return data;
  },
  async clone(id) {
    const { data } = await client.post(`/api/surveys/${id}/clone`);
    return data;
  },
  async extendExpiry(id, expiresAt) {
    const { data } = await client.patch(`/api/surveys/${id}/expiry`, { expiresAt });
    return data;
  },

  // Public — no auth, token-as-credential
  async loadPublic(customerId, token) {
    const { data } = await publicClient.get(`/api/public/surveys/${customerId}/${token}`);
    return data;
  },
  async autosavePublic(customerId, token, body) {
    const { data } = await publicClient.patch(`/api/public/surveys/${customerId}/${token}`, body);
    return data;
  },
  async submitPublic(customerId, token) {
    const { data } = await publicClient.post(`/api/public/surveys/${customerId}/${token}/submit`);
    return data;
  },
};
